/** constants */
import { SET_SHOW_MODAL, SET_HIDE_MODAL } from '../types'

/** actions creators  params [optional]  obj, array, str ... */
export const showModal = (title, path, nss) => {
  return dispatch =>  dispatch(setShowModal({title, path, nss}))
}

export const hideModal = () => {
  return dispatch => dispatch(setHideModal())
}

/** params [optional] return obj - {type: str-required, payload:optional} */
const setShowModal = (payload) => ({ type : SET_SHOW_MODAL, payload })

const setHideModal= () => ({ type : SET_HIDE_MODAL })